import React from "react";
import { Routes, Route } from "react-router-dom"; // No need for BrowserRouter here if used elsewhere
import ComingSoon from "./pages/comingsoon";

function App() {
  return <ComingSoon />;
}

export default App;
